import { storageSet } from './libs/localStorage';

window.changeBtnAddSetToBasket = () => {
  const parentWrapper = document.querySelector('.product-kit__subproducts');
  if (!parentWrapper) {
    return;
  }
  const btnsAdd = document.querySelectorAll('[data-action="addsettocart"]');
  const btnsLinkToBasket = document.querySelectorAll('[data-id="set_link_to_basket"]');
  if (parentWrapper.getElementsByClassName('product-kit__subproduct').length === parentWrapper.getElementsByClassName('already_in_basket').length) {
    btnsAdd.forEach((el) => {
      el.classList.add('d-none');
    });
    btnsLinkToBasket.forEach((el) => {
      el.classList.remove('d-none');
    });
  } else {
    btnsAdd.forEach((el) => {
      el.classList.remove('d-none');
    });
    btnsLinkToBasket.forEach((el) => {
      el.classList.add('d-none');
    });
  }
};

const getLocalStorageSets = () => {
  let sets = {};
  const localStorageSet = localStorage.getItem('sets');

  if (localStorageSet !== null) {
    sets = JSON.parse(localStorageSet);
  }
  return sets;
};

const addInLocalStorageDeletedItem = (parentID, id) => {
  const sets = getLocalStorageSets();

  if (!sets[parentID]) {
    sets[parentID] = [];
  }

  if (!sets[parentID].includes(id)) {
    sets[parentID].push(id);
  }
  window.localStorage.setItem('sets', JSON.stringify(sets));
};

const deleteFromLocalStorageDeletedItem = (parentID, id) => {
  const sets = getLocalStorageSets();

  if (sets[parentID] && sets[parentID].includes(id)) {
    sets[parentID] = sets[parentID].filter((x) => x !== id);
  }
  window.localStorage.setItem('sets', JSON.stringify(sets));
};

window.addEventListener('basketUpdate', () => {
  window.changeBtnAddSetToBasket();
});

const numberWithSpaces = (x) => {
  const parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.');
};

const backToSet = (id) => {
  const elID = `setitem-${id}`;
  const elems = document.querySelectorAll(`[data-id=${elID}]`);
  const cartBtns = document.querySelectorAll('[data-action="addsettocart"]');
  let parentID = null;
  let priceFormat = null;
  let quantity = null;

  elems.forEach((el) => {
    const parentElem = el.closest('.description-product__kit');
    priceFormat = cartBtns[0].dataset.currencyformat;
    parentID = document.querySelector('[data-set-product-id]').dataset.setProductId;
    // переместить в блок "готовый набор"
    el.querySelector('.product-kit__subproduct-delete-button').classList.remove('hidden');
    el.querySelector('.product-kit__deleted-subproduct-btn').classList.add('hidden');
    const deletedDiv = parentElem.querySelector('.product-kit__subproducts');
    deletedDiv.appendChild(el);
    el.classList.remove('product-kit__deleted-subproduct');
    el.classList.add('product-kit__subproduct');
    document.querySelector('.total-set-row').classList.remove('hidden');
    quantity = el.querySelector('.product-kit__subproduct-amount').dataset.quantity;
  });
  // пересчитать общую цену набора
  const totalElems = document.querySelectorAll('.product-kit__total-price');
  const total = parseFloat(totalElems[0].dataset.price);
  const elPrice = parseFloat(elems[0].querySelector('.product-kit__subproduct-price').dataset.price);
  const newTotal = parseFloat(total) + parseFloat(elPrice);
  totalElems.forEach((totalEl) => {
    totalEl.dataset.price = newTotal.toFixed(2);
    totalEl.innerHTML = priceFormat.replace('#', numberWithSpaces(newTotal.toFixed(2)));
  });

  // изменить датасет setid кнопки "добавить набор"
  const setId = JSON.parse(cartBtns[0].dataset.setid);
  setId.push({ id, quantity });
  cartBtns.forEach((el) => {
    el.dataset.setid = JSON.stringify(setId);
  });
  window.changeBtnAddSetToBasket();
  deleteFromLocalStorageDeletedItem(parentID, id);
};

const deleteFromSet = (id) => {
  const elID = `setitem-${id}`;
  const elems = document.querySelectorAll(`[data-id=${elID}]`);
  let parentID = null;
  let priceFormat = null;

  if (!elems.length) {
    return;
  }
  const cartBtns = document.querySelectorAll('[data-action="addsettocart"]');
  elems.forEach((el) => {
    const parentElem = el.closest('.description-product__kit');
    priceFormat = cartBtns[0].dataset.currencyformat;
    parentID = document.querySelector('[data-set-product-id]').dataset.setProductId;
    // переместить в блок "вернуть в набор"
    el.querySelector('.product-kit__subproduct-delete-button').classList.add('hidden');
    el.querySelector('.product-kit__deleted-subproduct-btn').classList.remove('hidden');
    el.classList.remove('product-kit__subproduct');
    el.classList.add('product-kit__deleted-subproduct');
    const deletedDiv = parentElem.querySelector('.product-kit__deleted-subproducts');
    deletedDiv.appendChild(el);
  });
  // пересчитать общую цену набора
  const totalElems = document.querySelectorAll('.product-kit__total-price');
  const total = parseFloat(totalElems[0].dataset.price).toFixed(2);
  const elPrice = parseFloat(elems[0].querySelector('.product-kit__subproduct-price').dataset.price).toFixed(2);
  const newTotal = parseFloat(total - elPrice).toFixed(2);
  totalElems.forEach((totalEl) => {
    totalEl.dataset.price = newTotal;
    totalEl.innerHTML = priceFormat.replace('#', numberWithSpaces(newTotal));
    if (+newTotal === 0) {
      document.querySelectorAll('.total-set-row').forEach((el) => { el.classList.add('hidden'); });
    }
  });

  // изменить датасет setid кнопки "добавить набор"
  cartBtns.forEach((cartBtn) => {
    const setId = JSON.parse(cartBtn.dataset.setid);
    const newSet = setId.filter((f) => +f.id !== +id);
    cartBtn.dataset.setid = JSON.stringify(newSet);
  });
  window.changeBtnAddSetToBasket();
  addInLocalStorageDeletedItem(parentID, id);
};

const deleteButtonHandler = (evt) => {
  const target = evt.target.classList.contains('product-kit__subproduct-delete-button')
    ? evt.target
    : evt.target.closest('.product-kit__subproduct-delete-button');

  const itemID = target.dataset.itemid;
  deleteFromSet(itemID);
};

const backToSetHandler = (evt) => {
  const target = evt.target.classList.contains('product-kit__deleted-subproduct-btn')
    ? evt.target
    : evt.target.closest('.product-kit__deleted-subproduct-btn');

  const itemID = target.dataset.itemid;
  backToSet(itemID);
};

const initSets = () => {
  document.querySelectorAll('.product-kit__subproduct-delete-button').forEach((item) => {
    item.removeEventListener('click', deleteButtonHandler);
    item.addEventListener('click', deleteButtonHandler);
  });
  document.querySelectorAll('.product-kit__deleted-subproduct-btn').forEach((item) => {
    item.removeEventListener('click', backToSetHandler);
    item.addEventListener('click', backToSetHandler);
  });

  const setToCartBtns = document.querySelectorAll('[data-action="addsettocart"]');
  if (setToCartBtns.length) {
    setToCartBtns.forEach((setToCartBtn) => {
      setToCartBtn.addEventListener('click', async () => {
        const setdata = JSON.stringify(JSON.parse(setToCartBtn.dataset.setid));
        const sessId = window.localStorage.getItem('sessId');

        const data = {
          ajax_basket: 'Y',
          data: setdata,
          productId: setToCartBtn.dataset.productId,
          action: 'addset',
          sessid: sessId || '',
        };
        const formData = new FormData();
        const keys = Object.keys(data);
        keys.forEach((key) => {
          formData.append(`${key}`, data[key]);
        });

        const url = '/local/ajax/basket/';

        try {
          const respone = await fetch(url, {
            method: 'POST',
            body: formData,
          });
          const result = await respone.json();

          storageSet({ key: 'basketItems', value: result });
          window.basketUpdate();
          window.changeBtnAddSetToBasket();

          return result;
        } catch (e) {
        // eslint-disable-next-line
        console.error(e);

          return null;
        }
      });
    });
  }

  const sets = getLocalStorageSets();
  const parentEl = document.querySelector('[data-set-product-id]');
  let parentID = 0;
  if (parentEl) {
    parentID = parentEl.dataset.setProductId;
  }

  if (parentID > 0 && sets[parentID]) {
    sets[parentID].forEach((el) => {
      deleteFromSet(el);
    });
  }
};

window.initSets = initSets;
document.addEventListener('DOMContentLoaded', () => {
  initSets();
});
